import { CSSProperties, FC, ReactNode } from 'react';
import * as RadixTooltip from '@radix-ui/react-tooltip';

interface TooltipProps {
  children: ReactNode;
  content: ReactNode;
  side?: 'top' | 'right' | 'bottom' | 'left';
  align?: 'start' | 'center' | 'end';
  delayDuration?: number;
  wrapperClassName?: string;
  style?: CSSProperties;
  onClick?: () => void;
}

export const Tooltip: FC<TooltipProps> = ({
  children,
  content,
  side = 'top',
  align = 'center',
  delayDuration = 200,
  wrapperClassName,
  style,
  onClick,
}) => {
  return (
    <RadixTooltip.Provider delayDuration={delayDuration}>
      <RadixTooltip.Root>
        <RadixTooltip.Trigger asChild>
          <button
            type="button"
            style={style}
            onClick={onClick}
            className={
              wrapperClassName ??
              'inline-flex items-center justify-center border-0 bg-transparent p-0 outline-none cursor-pointer text-inherit'
            }
          >
            {children}
          </button>
        </RadixTooltip.Trigger>

        <RadixTooltip.Portal>
          <RadixTooltip.Content
            side={side}
            align={align}
            sideOffset={5}
            className="z-9999 max-w-64 rounded-lg bg-(--neutral-white-NW1000) p-3 [font-size:var(--fs-l5)]! font-medium text-(--primary-O1000) shadow-lg transition-opacity duration-150"
          >
            {content}
            <RadixTooltip.Arrow className="fill-(--neutral-white-NW1000)" />
          </RadixTooltip.Content>
        </RadixTooltip.Portal>
      </RadixTooltip.Root>
    </RadixTooltip.Provider>
  );
};
